/* eslint-disable radix */

const DURATION_INCREMENTER = 5;
const MAX_DURATION = 480;
const durations = [];

const DurationUtils = {
  formatDuration(duration) {
    const rest = duration % 60;
    const hours = Number.parseInt(duration / 60);
    let name = '';

    if (duration === 0) {
      return '0 min';
    }
    if (hours > 0) {
      name += `${hours} h`;
    }
    if (rest > 0) {
      name += ` ${rest} min`;
    }

    return name;
  },

  getDurationList() {
    if (durations.length > 0) {
      return durations;
    }

    let duration = 5;
    while (duration <= MAX_DURATION) {
      durations.push({
        name: DurationUtils.formatDuration(duration),
        id: duration,
      });
      duration += DURATION_INCREMENTER;
    }

    durations.push({
      name: '8 h 30 min',
      id: 510,
    });
    durations.push({
      name: '9 h',
      id: 540,
    });
    durations.push({
      name: '10 h',
      id: 10 * 60,
    });
    durations.push({
      name: '11 h',
      id: 11 * 60,
    });
    durations.push({
      name: '12 h',
      id: 12 * 60,
    });
    return durations;
  },

  updateDurationOptions(newDurationValue) {
    const existsDuration = durations.some((p) => p.id === newDurationValue);
    if (!existsDuration) {
      const numberOfHours = Number.parseInt(newDurationValue / 60);
      const numberOfMinutes = newDurationValue % 60;
      const minutesString = numberOfMinutes > 0 ? `${numberOfMinutes} min` : '';

      durations.push({
        name: `${numberOfHours} h ${minutesString}`,
        id: newDurationValue,
      });
    }
  },
};

export { DurationUtils as default };
